import React from 'react'
import i18next from 'i18next'
import {Trans} from 'react-i18next'
import {urls} from '@/constants/urls'

export const ourSupportTeamIsHereToHelp = (message: string) => (
    <>
        {message ? (
            <>
                {message}
                <br />
            </>
        ) : (
            i18next.t('Login.ourSupportTeamIsHereToHelp.text1')
        )}
        <Trans
            i18nKey='Login.ourSupportTeamIsHereToHelp.text2'
            components={{
                a: (
                    <a
                        href={urls.supportFormUrl}
                        target={'_blank'}
                        rel={'noreferrer'}
                    />
                )
            }}
        />
    </>
)
